import { Box, Typography } from '@mui/material'
import { DataGridTable } from 'components'
import { getDriverListTableColumns } from './driverListTableData'
import { MappedDriver } from 'interfaces/IDrivers'
import { useGridApiRef } from '@mui/x-data-grid'
import { exportTableAsCSV } from 'tools/helper'
import strings from 'strings'

const e = strings.CSV_EXPORT

interface IDriverListTableProps {
  loading: boolean
  data: MappedDriver[]
  useKilometers?: boolean
}

const DriverListTable: React.FC<IDriverListTableProps> = ({
  data,
  loading,
  useKilometers = false,
}) => {
  const apiRef = useGridApiRef()

  const handleExport = () => {
    const csvString = apiRef.current.getDataAsCsv()
    exportTableAsCSV(csvString, e.DRIVER_LIST_CSV_EXPORT_NAME)
  }
  const tableMenuItems = [
    {
      label: e.DOWNLOAD_AS_CSV,
      key: 'export',
      action: () => {
        handleExport()
      },
    },
  ]
  return (
    <Box>
      <Typography variant="h2" color="text.primary" gutterBottom sx={{ mb: 2 }}>
        Driver List
      </Typography>
      <DataGridTable
        apiRef={apiRef}
        showTitle={false}
        data={data}
        columns={getDriverListTableColumns(useKilometers)}
        columnVisibilityModel={{
          rowId: false,
        }}
        checkboxSelection={false}
        totalCount={data.length}
        multiSearchFilter={false}
        getRowId={(row: any) => row.rowId}
        loading={loading}
        menuList={tableMenuItems}
      />
    </Box>
  )
}

export default DriverListTable
